module.exports = __webpack_public_path__ + "img/Haefele_menu8.cc6f922c.png";